import { Component, OnInit } from '@angular/core';
import { ConfiguratorService } from '../shared/services/configurator-service/configurator.service';
import { AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { CustomerService } from '../shared/services/customer-services/customer.service';
import { Subscription, connect } from 'rxjs';
import { UserService } from '../shared/services/user-services/user.service';
import { ToastrMsgService } from '../shared/services/shared-services/toastr.service';

@Component({
  selector: 'app-custumer-customerprofile-schememanager',
  templateUrl: './custumer-customerprofile-schememanager.component.html',
  styleUrls: ['./custumer-customerprofile-schememanager.component.css'],
})
export class CustumerCustomerprofileSchememanagerComponent implements OnInit {
  payOutTableData = [
    {
      range: '1-1000',
      chargeType: '',
      partner: 'Enter Value',
      rangeChargeType: 'chargeTypeOne',
      rangeChargeFintrex: 'chargeFintraxOne',
      rangeChargePartner: 'chargePartnerOne',
      rangeChargeReseller: 'chargeResellerOne',
      // rangeChargeMerchant: 'chargeMerchantOne',
    },
    {
      range: '1000-25000',
      chargeType: '',
      partner: 'Enter Value',
      rangeChargeType: 'chargeTypeTwo',
      rangeChargeFintrex: 'chargeFintraxTwo',
      rangeChargePartner: 'chargePartnerTwo',
      rangeChargeReseller: 'chargeResellerTwo',
      // rangeChargeMerchant: 'chargeMerchantTwo',
    },
    {
      range: '25000-500000',
      chargeType: '',
      partner: 'Enter Value',
      rangeChargeType: 'chargeTypeThree',
      rangeChargeFintrex: 'chargeFintraxThree',
      rangeChargePartner: 'chargePartnerThree',
      rangeChargeReseller: 'chargeResellerThree',
      // rangeChargeMerchant: 'chargeMerchantThree',
    },
    // {
    //   range: 2,
    //   chargeType: '',
    //   partner: 'Enter Value',
    //   rangeChargeType: 'chargeTypeFour',
    //   rangeChargeFintrex: 'chargeFintraxFour',
    //   rangeChargePartner: 'chargePartnerFour',
    //   rangeChargeReseller: 'chargeResellerFour',
    //   rangeChargeMerchant: 'chargeMerchantFour',
    // },
  ];
  allRoles:any =  ['admin', 'partner']
  schemeData: any = [];
  selectedSchemeID = '';
  selectedSchemeData: any;

  customerSchemeProviderForm!: FormGroup;
  selectedScheme: any;
  providerData: any = [];
  providerDataPayin: any = [];
  providerDataPayout: any = [];
  selectedProviderPayIn: any;
  selectedProviderPayOut: any;
  customerDataObsSubscription!: Subscription;
  customerDataEventObsSubscription!: Subscription;
  userId: any;
  resData: any;
  currentUserRole: any;
  partnerId: any;

  constructor(
    private schemeServies: ConfiguratorService,
    private formBuilder: FormBuilder,
    private schemeService: ConfiguratorService,
    private customerService: CustomerService,
    private userService: UserService,
    private toastrService: ToastrMsgService
  ) {}

  onClick(ev: any) {
    this.selectedSchemeID = ev.target.value;
    this.selectedSchemeData = this.schemeData.data.find(
      (e: any) => e._id == this.selectedSchemeID
    );
  }

  ngOnInit() {
    this.resData = this.userService.getUserRole();
    this.partnerId = this.userService.getUserDetailsFromSession().createdBy;
    this.initForm();
    this.getSchemeData();
    if (this.resData == 'reseller') {
      this.getProviders('');
    }

    this.customerDataObsSubscription = this.customerService
      .getCustomerDataObservable()
      .subscribe((res) => {
        this.currentUserRole = res?.role?.type;
        console.log("o",this.currentUserRole)
        this.userId = res._id;
        this.patchCustomerSchemeProviderDetailsData(res);
      });
    this.customerDataEventObsSubscription = this.customerService
      .getCustomerFormDataEventObsevable()
      .subscribe((res) => {
        console.log("res",this.customerSchemeProviderForm)
        let payload = { ...this.customerSchemeProviderForm.value };
        payload.schemeId = this.customerSchemeProviderForm.value?.schemeId;
        payload.schemeName = this.customerSchemeProviderForm.value?.schemeName;
        payload.selectedProviderPayIn = this.selectedProviderPayIn
          ? this.selectedProviderPayIn
          : res?.providerConfig?.payIn;
        payload.selectedProviderPayOut = this.selectedProviderPayOut
          ? this.selectedProviderPayOut
          : res?.providerConfig?.payOut;
        if (this.customerSchemeProviderForm.valid) {
          payload.validCustomerSchemeProviderForm = true;
          this.customerService.sendCustomerFormData(payload);
          console.log('called');
        } else {
          payload.validCustomerSchemeProviderForm = false;
          this.customerSchemeProviderForm.markAllAsTouched();
          this.customerService.sendCustomerFormData(payload);
          console.log('called2');
        }
        console.log(payload)
      });
  }

  patchCustomerSchemeProviderDetailsData(data: any) {
    this.customerSchemeProviderForm.patchValue({
      chargeType: data?.schemeConfig?.payIn?.chargeType
        ? data?.schemeConfig?.payIn?.chargeType
        : 'flat',
      payInFintrax: data?.schemeConfig?.payIn?.fintegrator,
      payInReseller: data?.schemeConfig?.payIn?.reseller,
      payInPartner: data?.schemeConfig?.payIn?.partner,
      chargeTypeOne: data?.schemeConfig?.payOut[0]?.chargeType
        ? data?.schemeConfig?.payOut[0]?.chargeType
        : 'flat',
      chargeTypeTwo: data?.schemeConfig?.payOut[1]?.chargeType
        ? data?.schemeConfig?.payOut[1]?.chargeType
        : 'flat',
      chargeTypeThree: data?.schemeConfig?.payOut[2]?.chargeType
        ? data?.schemeConfig?.payOut[2]?.chargeType
        : 'flat',
      chargePartnerOne: data?.schemeConfig?.payOut[0]?.partner,
      chargePartnerTwo: data?.schemeConfig?.payOut[1]?.partner,
      chargePartnerThree: data?.schemeConfig?.payOut[2]?.partner,
      chargeResellerOne: data?.schemeConfig?.payOut[0]?.reseller,
      chargeResellerTwo: data?.schemeConfig?.payOut[1]?.reseller,
      chargeResellerThree: data?.schemeConfig?.payOut[2]?.reseller,
      chargeFintraxOne: data?.schemeConfig?.payOut[0]?.fintegrator,
      chargeFintraxTwo: data?.schemeConfig?.payOut[1]?.fintegrator,
      chargeFintraxThree: data?.schemeConfig?.payOut[2]?.fintegrator,
      providerPayIn: data?.providerConfig?.payIn?.providerId,
      providerPayOut: data?.providerConfig?.payOut?.providerId,
      schemeId: data?.schemeConfig?.schemeId,
      schemeName: data?.schemeConfig?.schemeName,
    });
    console.log(this.customerSchemeProviderForm.value, data)
  }

  initForm() {
    this.customerSchemeProviderForm = this.formBuilder.group({
        chargeType: ['flat'],
        payInFintrax: ['', [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
        payInReseller: ['', [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
        payInPartner: ['', [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
        chargeTypeOne: ['flat'],
        chargeTypeTwo: ['flat'],

        chargeTypeThree: ['flat'],
        // chargeTypeFour: [''],
        chargeFintraxOne: ['', [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
        chargeFintraxTwo: ['', [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
        chargeFintraxThree: ['', [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
        // chargeFintraxFour: [''],

        chargePartnerOne: ['', [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
        chargePartnerTwo: ['', [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
        chargePartnerThree: ['', [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
        // chargePartnerFour: [''],
        chargeResellerOne: ['', [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
        chargeResellerTwo: ['', [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
        chargeResellerThree: ['', [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
        // chargeResellerFour: [''],
        // chargeMerchantOne: ['', [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
        // chargeMerchantTwo: ['', [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
        // chargeMerchantThree: ['',[Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
        // chargeMerchantFour: [''],
        providerPayIn: [''],
        providerPayOut: [''],
        schemeId: [''],
        schemeName: [''],
      },
      { validator: this.relatedValueOrderValidator() }
    );

    if(this.resData == 'partner') {
    this.customerSchemeProviderForm.get('payInPartner')?.addValidators(Validators.required);
    this.customerSchemeProviderForm.get('payInPartner')?.updateValueAndValidity();
    this.customerSchemeProviderForm.get('chargePartnerOne')?.addValidators(Validators.required);
    this.customerSchemeProviderForm.get('chargePartnerOne')?.updateValueAndValidity();
    this.customerSchemeProviderForm.get('chargePartnerTwo')?.addValidators(Validators.required);
    this.customerSchemeProviderForm.get('chargePartnerTwo')?.updateValueAndValidity();
    this.customerSchemeProviderForm.get('chargePartnerThree')?.addValidators(Validators.required);
    this.customerSchemeProviderForm.get('chargePartnerThree')?.updateValueAndValidity();
    }
    if(this.resData == 'reseller') {
      this.customerSchemeProviderForm.get('schemeId')?.addValidators(Validators.required);
      this.customerSchemeProviderForm.get('schemeId')?.updateValueAndValidity();
      this.customerSchemeProviderForm.get('providerPayIn')?.addValidators(Validators.required);
      this.customerSchemeProviderForm.get('providerPayIn')?.updateValueAndValidity();
      this.customerSchemeProviderForm.get('providerPayOut')?.addValidators(Validators.required);
      this.customerSchemeProviderForm.get('providerPayOut')?.updateValueAndValidity();
    }

  }

  relatedValueOrderValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      console.log('test');
      const firstValue1 = control.get('chargeFintraxOne')?.value;
      const secondValue1 = control.get('chargePartnerOne')?.value;
      const thirdValue1 = control.get('chargeResellerOne')?.value;

      const firstValue2 = control.get('chargeFintraxTwo')?.value;
      const secondValue2 = control.get('chargePartnerTwo')?.value;
      const thirdValue2 = control.get('chargeResellerTwo')?.value;

      const firstValue3 = control.get('chargeFintraxThree')?.value;
      const secondValue3 = control.get('chargePartnerThree')?.value;
      const thirdValue3 = control.get('chargeResellerThree')?.value;

      const firstValue4 = control.get('payInFintrax')?.value;
      const secondValue4 = control.get('payInPartner')?.value;
      const thirdValue4 = control.get('payInReseller')?.value;

      if (
        secondValue1 <= firstValue1 ||
        thirdValue1 <= secondValue1 ||
        secondValue2 <= firstValue2 ||
        thirdValue2 <= secondValue2 ||
        secondValue3 <= firstValue3 ||
        thirdValue3 <= secondValue3 
      ) {
        console.log(this.customerSchemeProviderForm);
        return { invalidOrder: true };
      }
      else if(
        secondValue4 <= firstValue4 ||
        thirdValue4 <= secondValue4){
          console.log(this.customerSchemeProviderForm);
          return { invalidOrders: true };
        }

      return null;
    };
  }

  // checkPercentageValidator(chargeType: any, chargeValue: any) {
  //  if(this.customerSchemeProviderForm.get(chargeType)?.value == 'percentage') {
  //     if(Number(this.customerSchemeProviderForm.get(chargeValue)?.value)  < 0 ||
  //     Number(this.customerSchemeProviderForm.get(chargeValue)?.value)  > 100) {
  //       this.customerSchemeProviderForm.get(chargeValue)?.setErrors({'percentageValid': true})
  //      }
  //      else {
  //       this.customerSchemeProviderForm.get(chargeValue)?.setErrors({'percentageValid': false})
  //     }
  //   }
  // }

  getProviders(type: any) {
    let pagination = {
      limit: 1000,
      currentPage: 1,
    };
    this.schemeService
      .getAllProviderWithPagination(pagination, type, this.partnerId)
      .subscribe({
        next: (response: any) => {
          console.log("i",response)
          this.providerDataPayin = [];
          this.providerDataPayout = [];
          this.providerDataPayout = response?.data?.data?.filter((item: any) => {
            return item.txType == 'PayOut' || item.txType == 'PayIn/PayOut'; 
            } )
            this.providerDataPayin = response?.data?.data?.filter((item: any) => {
              return item.txType == 'PayIn' || item.txType == 'PayIn/PayOut'; 
          });

          // this.providerData = response?.data?.data;
          // this.providerDataPayin = [];
          // this.providerDataPayout = [];
          // if(type == 'payin') {
          //   this.providerDataPayin = response?.data?.data;
          // }
          // if(type == 'payout') {
          //   this.providerDataPayout = response?.data?.data;
          // }
        },
        error: (error) => {
          console.error('Error  Creating state:', error);
        },
        complete: () => {
          console.log('Create request completed');
        },
      });
  }

  onProviderPayInSelect(ev: any) {
    this.selectedProviderPayIn = this.providerDataPayin.find(
      (item: any) => item._id == ev.target.value
    );
  }

  onProviderPayoutSelect(ev: any) {
    this.selectedProviderPayOut = this.providerDataPayout.find(
      (item: any) => item._id == ev.target.value
    );
  }

  getSchemeData() {
    this.schemeService.getAllSchemes().subscribe({
      next: (response: any) => {
        this.schemeData = response.data.filter((item: any) => {
          return (
            item.userId == this.userService.getUserDetailsFromSession()._id &&
            item.status == 'active'
          );
        });
      },
      error: (error) => {
        console.error('Error  Creating state:', error);
      },
      complete: () => {
        console.log('Create request completed');
      },
    });
  }

  getPayOutArray() {
    return Object.entries(this.selectedSchemeData.payOut).map(
      (e: [string, any]) => {
        return {
          range: e[0],
          chargeType: e[1].chargeType,
          partner: e[1].partner,
        };
      }
    );
  }

  onSchemeSelect(ev: any) {
    this.selectedScheme = this.schemeData.find(
      (item: any) => item._id == ev.target.value
    );
    console.log(this.selectedScheme)
    this.customerSchemeProviderForm.patchValue({
      chargeType: this.selectedScheme?.payIn?.chargeType
        ? this.selectedScheme?.payIn?.chargeType
        : 'flat',
      payInFintrax: this.selectedScheme?.payIn?.fintegrator,
      payInReseller: this.selectedScheme?.payIn?.reseller,
      payInPartner: this.selectedScheme?.payIn?.partner,
      chargeTypeOne: this.selectedScheme?.payOut[0]?.chargeType
        ? this.selectedScheme?.payOut[0]?.chargeType
        : 'flat',
      chargeTypeTwo: this.selectedScheme?.payOut[1]?.chargeType
        ? this.selectedScheme?.payOut[1]?.chargeType
        : 'flat',
      chargeTypeThree: this.selectedScheme?.payOut[2]?.chargeType
        ? this.selectedScheme?.payOut[2]?.chargeType
        : 'flat',
      chargePartnerOne: this.selectedScheme?.payOut[0]?.partner,
      chargePartnerTwo: this.selectedScheme?.payOut[1]?.partner,
      chargePartnerThree: this.selectedScheme?.payOut[2]?.partner,
      chargeResellerOne: this.selectedScheme?.payOut[0]?.reseller,
      chargeResellerTwo: this.selectedScheme?.payOut[1]?.reseller,
      chargeResellerThree: this.selectedScheme?.payOut[2]?.reseller,
      chargeFintraxOne: this.selectedScheme?.payOut[0]?.fintegrator,
      chargeFintraxTwo: this.selectedScheme?.payOut[1]?.fintegrator,
      chargeFintraxThree: this.selectedScheme?.payOut[2]?.fintegrator,
      schemeId: this.selectedScheme?._id,
      schemeName: this.selectedScheme?.schemeName,
    });
    console.log(
      'this.customerSchemeProviderForm.value',
      this.customerSchemeProviderForm.value
    );
    // this.customerService.sendCustomerFormData(
    //   this.customerSchemeProviderForm.value
    // );
  }

  updateDisableForm() {
    if(this.resData == 'admin') {
      this.customerSchemeProviderForm.get('chargeType')?.disable();
      this.payOutTableData.forEach((item: any) => {
      this.customerSchemeProviderForm.get('chargeType')?.updateValueAndValidity();
      this.customerSchemeProviderForm.get([item.rangeChargeType])?.disable();
      this.customerSchemeProviderForm
        .get([item.rangeChargeType])
        ?.updateValueAndValidity();
      console.log('called')
    });
    }
    else if (this.resData == 'partner') {
      this.payOutTableData.forEach((item: any) => {
        this.customerSchemeProviderForm
          .get([item.rangeChargeFintrex])
          ?.disable();
        this.customerSchemeProviderForm
          .get([item.rangeChargeFintrex])
          ?.updateValueAndValidity();
        this.customerSchemeProviderForm.get([item.rangeChargeType])?.disable();
        this.customerSchemeProviderForm
          .get([item.rangeChargeType])
          ?.updateValueAndValidity();
        this.customerSchemeProviderForm.get(['chargeType'])?.disable();
        this.customerSchemeProviderForm
          .get(['chargeType'])
          ?.updateValueAndValidity();
        this.customerSchemeProviderForm.get(['payInFintrax'])?.disable();
        this.customerSchemeProviderForm
          .get(['payInFintrax'])
          ?.updateValueAndValidity();
      });
    } else if (this.resData == 'reseller') {
      this.payOutTableData.forEach((item: any) => {
        this.customerSchemeProviderForm
          .get([item.rangeChargePartner])
          ?.disable();
        this.customerSchemeProviderForm
          .get([item.rangeChargePartner])
          ?.updateValueAndValidity();
        this.customerSchemeProviderForm.get([item.rangeChargeType])?.disable();
        this.customerSchemeProviderForm
          .get([item.rangeChargeType])
          ?.updateValueAndValidity();
        this.customerSchemeProviderForm
          .get([item.rangeChargeReseller])
          ?.disable();
        this.customerSchemeProviderForm
          .get([item.rangeChargeReseller])
          ?.updateValueAndValidity();
        this.customerSchemeProviderForm.get(['chargeType'])?.disable();
        this.customerSchemeProviderForm
          .get(['chargeType'])
          ?.updateValueAndValidity();
        this.customerSchemeProviderForm.get(['payInPartner'])?.disable();
        this.customerSchemeProviderForm
          .get(['payInPartner'])
          ?.updateValueAndValidity();
        this.customerSchemeProviderForm.get(['payInReseller'])?.disable();
        this.customerSchemeProviderForm
          .get(['payInReseller'])
          ?.updateValueAndValidity();
      });
    }
  }
}
